module.exports = __webpack_public_path__ + "static/media/peripheral-arthritis-icon.d120b312.svg";